// The sign-up password rules. PasswordHints lists them and the Continue button
// is gated on all of them, so a rule can't block someone without being shown.
export const PASSWORD_RULES = [
  { id: 'length', label: 'At least 10 characters', test: (p) => p.length >= 10 },
  { id: 'letter', label: 'A letter', test: (p) => /[a-zA-Z]/.test(p) },
  { id: 'number', label: 'A number', test: (p) => /[0-9]/.test(p) },
];

export const isValidPassword = (p) => PASSWORD_RULES.every((rule) => rule.test(p));
